<template>
  <v-container
    grid-list-md
    fluid
    class="pa-0"
  >
    <v-layout row>
      <v-flex>
        <v-card class="max-shadow">
          <v-toolbar
            flat
            color="white"
          >
            <v-spacer />
            <v-toolbar-items>
              <DatePicker
                v-model="selectedDate"
                :max="new Date().toISOString().substring(0,10)"
                type="date"
                @change="fetchOrders" 
              />
            </v-toolbar-items>
            <v-btn
              color="primary"
              flat
              @click.stop="advanceExportDialog = true"
            >
              Advance Export
            </v-btn>
          </v-toolbar>
          <v-dialog
            v-model="advanceExportDialog"
            max-width="690"
          >
            <v-card class="max-shadow">
              <v-card-title class="headline">
                Advance Export
              </v-card-title>
              <v-card-text>
                <v-layout
                  row
                  wrap
                  justify-space-around
                >
                  <v-layout
                    row
                    wrap
                    align-center
                    justify-center
                  >
                    <span>Start Date :</span>
                    <DatePicker
                      v-model="AEStartDate"
                      :max="AEEndDate"
                      :prev-next-btns="false"
                      type="date"
                    />
                  </v-layout>
                  <v-layout
                    row
                    wrap
                    align-center
                    justify-center
                  >
                    <span>End Date :</span>
                    <DatePicker
                      v-model="AEEndDate"
                      :max="AEEndDate"
                      :prev-next-btns="false"
                      type="date"
                    />
                  </v-layout>
                </v-layout>
              </v-card-text>
              <v-card-actions>
                <v-spacer />
                <v-btn
                  color="primary"
                  flat
                  @click.native="advanceExportDialog = false"
                >
                  Cancel
                </v-btn>
                <v-btn
                  color="primary"
                  flat
                  @click.native="advanceExport"
                >
                  Export
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-data-table
            :headers="ordersHeaders"
            :items="orders"
            :search="search"
            :loading="ordersLoading"
            :no-results-text="'Your search for ' + search + ' found no results.'"
            class="px-2 pb-2"
            item-key="id"
            no-data-text="No orders to show"
            hide-actions
            disable-initial-sort
          >
            <template
              slot="items"
              slot-scope="props"
            >
              <tr>
                <td>{{ props.index + 1 }}</td>
                <td class="text-xs-left">
                  {{ props.item.orderedBy.name }}
                </td>
                <td class="text-xs-left">
                  {{ formatDate(props.item.orderedAt) }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.status }}
                </td>
                <td class="text-xs-left">
                  {{ props.item.paymentStatus }}
                </td>
                <td class="text-xs-left">
                  {{ getOrderTotal(props.item) }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import { firestore } from '@/firebase';
import moment from 'moment';

import DatePicker from '@/components/common/DatePicker';

export default {
  name: 'Orders',
  components: {
    DatePicker
  },
  props: {
    vendorId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      orders: [],
      ordersHeaders: [
        {
          text: '#',
          value: false,
          align: 'left'
        },
        {
          text: 'Ordered By',
          value: 'orderedBy.name',
          align: 'left'
        },
        {
          text: 'Ordered At',
          value: 'orderedAt',
          align: 'left'
        },
        {
          text: 'Status',
          value: 'Status',
          align: 'left'
        },
        {
          text: 'Payment Status',
          value: 'paymentStatus',
          align: 'left'
        },
        {
          text: 'Order Total',
          value: false,
          align: 'left'
        }
      ],
      search: '',
      selectedDate: new Date().toISOString().substring(0, 10),
      ordersLoading: true,
      AEStartDate: '',
      AEEndDate: '',
      advanceExportDialog: false
    };
  },
  created() {
    this.fetchOrders();
  },
  methods: {
    fetchOrders() {
      this.ordersLoading = true;
      firestore
        .collection('fnb')
        .where('vendorId', '==', this.vendorId)
        .where('orderedAt', '>=', moment(this.selectedDate).toDate())
        .where(
          'orderedAt',
          '<',
          moment(this.selectedDate)
            .add(1, 'day')
            .toDate()
        )
        .orderBy('orderedAt', 'desc')
        .limit(15)
        .get()
        .then(ordersSnap => {
          this.orders = [];
          ordersSnap.forEach(orderSnap => {
            this.orders.push(
              Object.assign({ id: orderSnap.id }, orderSnap.data(), {
                orderedAt: orderSnap
                  .data()
                  .orderedAt.toDate()
                  .toISOString()
              })
            );
          });
        })
        .catch(error => console.log(error))
        .then(() => (this.ordersLoading = false));
    },

    formatDate(date) {
      return moment(date).format('DD MMM YYYY HH:mm A');
    },

    getOrderTotal(order) {
      const itemsTotal = Object.keys(order.items).reduce((total, itemId) => {
        const item = order.items[itemId];
        return (
          total + item.quantity * item.item.price * (1 + item.item.gst / 100)
        );
      }, 0);

      const totalAmount = Math.round(itemsTotal + order.packingCharges);
      return totalAmount.toLocaleString('en-IN', {
        minimumFractionDigits: 2,
        currency: 'INR'
      });
    },
    
    advanceExport() {
      const startAt = moment(this.AEStartDate, this.dateFormat)
        .startOf('day')
        .utc()
        .toDate();
      const endAt = moment(this.AEEndDate, this.dateFormat)
        .endOf('day')
        .utc()
        .toDate();
      firestore
        .collection('fnb')
        .orderBy('orderedAt', 'desc')
        .where('orderedAt', '>=', startAt)
        .where('orderedAt', '<=', endAt)
        .where('vendorId', '==', this.vendorId)
        .get()
        .then(snapshot => {
          const AEvisitorLog = snapshot.docs.map(doc => {
            const val = doc.data();
            val.id = doc.id;
            return val;
          });

          if (AEvisitorLog.length !== 0) {
            this.exportVisitorLog(AEvisitorLog);
            this.advanceExportDialog = false;
          } else {
            this.snackbarMessage =
              'No Logs found to export on the selected dates';
            this.snackbar = true;
            this.advanceExportDialog = false;
          }
        });
    }
  }
};
</script>
